import React, { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  HiOutlineFolderOpen,
  HiOutlineTrash,
  HiOutlineStar,
  HiOutlineClock,
  HiPlus,
} from 'react-icons/hi';
import { useTheme } from '../../context/ThemeContext';

const DATA_SOURCES = ['Postgres (GCP)', 'Local'];
const LLM_PROVIDERS = ['OpenAI', 'Azure OpenAI', 'Anthropic'];

function NlpEngineHeader({
  connected,
  dataSource,
  onDataSourceChange,
  llmProvider,
  onLlmProviderChange,
  onClearSession,
  onNewChat,
}) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isDark, toggleTheme } = useTheme();
  const isGroupingView = searchParams.get('view') === 'grouping';

  const handleGroupingClick = () => {
    if (isGroupingView) {
      navigate('/continuous-improvements/analytics-and-nlp');
    } else {
      navigate('/continuous-improvements/analytics-and-nlp?view=grouping');
    }
  };

  const handleNewChat = useCallback(() => {
    onNewChat?.();
    if (isGroupingView) {
      navigate('/continuous-improvements/analytics-and-nlp');
    }
  }, [isGroupingView, navigate, onNewChat]);

  return (
    <header className="nlp-engine-header">
      <div className="nlp-engine-header-left">
        <div className="nlp-engine-brand-meta" style={{paddingLeft: '10px'}}>
          <span className="nlp-engine-subtitle">NLP INTELLIGENCE ENGINE</span>
          <span className={`nlp-engine-status ${connected ? 'connected' : 'disconnected'}`}>
            <span className="nlp-engine-status-dot" aria-hidden="true" />
            {connected ? 'Connected' : 'Disconnected'}
          </span>
        </div>
      </div>

      <div className="nlp-engine-header-right">
        <button
          type="button"
          className={`nlp-engine-btn nlp-engine-grouping-btn ${isGroupingView ? 'active' : ''}`}
          onClick={handleGroupingClick}
          aria-pressed={isGroupingView}
        >
          <HiOutlineFolderOpen size={15} />
          <span>Grouping &amp; RCA</span>
        </button>

        <select
          className="nlp-engine-select"
          value={dataSource}
          onChange={(e) => onDataSourceChange(e.target.value)}
          aria-label="Data source"
        >
          {DATA_SOURCES.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>

        <button
          type="button"
          className="nlp-engine-icon-btn"
          onClick={onClearSession}
          aria-label="Clear session"
          title="Clear session"
        >
          <HiOutlineTrash size={15} />
        </button>

        <select
          className="nlp-engine-select"
          value={llmProvider}
          onChange={(e) => onLlmProviderChange(e.target.value)}
          aria-label="LLM provider"
        >
          {LLM_PROVIDERS.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>

        <button
          type="button"
          className="nlp-engine-theme-dot"
          onClick={toggleTheme}
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        />

        <button type="button" className="nlp-engine-icon-btn" aria-label="Favorites" title="Favorites">
          <HiOutlineStar size={15} />
        </button>

        <button type="button" className="nlp-engine-icon-btn" aria-label="History" title="History">
          <HiOutlineClock size={15} />
        </button>

        <button type="button" className="nlp-engine-new-btn" onClick={handleNewChat}>
          <HiPlus size={15} />
          <span>New</span>
        </button>
      </div>
    </header>
  );
}

export default NlpEngineHeader;
